import React, { memo } from "react";
import { TeethIcon } from "@/utlility/icons";

const SectionTitle = ({ sectionName, title, isH1 = false, className = "", ...rest }) => {
  const Component = isH1 ? "h1" : "h2";
  return (
    <div className={`comman-section-title ${className}`} {...rest}>
      {sectionName && (
        <span className="section-name text-uppercase">
          <i><TeethIcon size={16} /></i>
          {sectionName}
        </span>
      )}
      {title && (
        <Component className="section-title text-capitalize">{title}</Component>
      )}
    </div>
  );
};

export default memo(SectionTitle);
